import React from "react";
import { CtaButtons } from "./CtaButtons";
export function FinalCta() {
  return <section id="unirme" className="px-6 py-24 text-center sm:py-32" data-id="element-30" data-mp="vffvgpvh26si">
      <div className="mx-auto max-w-2xl" data-id="element-31" data-mp="vhajid21if0t">
        <p className="mb-4 text-sm font-semibold text-gold" data-id="element-32" data-mp="19f7g39ghulfh">Sumate ahora</p>
        <h2 className="mb-4 font-serif text-[clamp(32px,5vw,52px)] font-bold leading-tight" data-id="element-33" data-mp="15ddkhfl5o7m6">
          Tu primer ebook puede empezar hoy
        </h2>
        <p className="mb-8 text-base leading-relaxed text-muted" data-id="element-34" data-mp="1jbtwnm1seqbp">
          Comunidad activa, asesoría semanal y el sistema completo para vender en Argentina y al mundo.
        </p>
        <p className="mb-10 text-[15px] text-soft" data-id="element-35" data-mp="1t1wovk13408z">
          <span className="font-serif text-3xl font-black text-white" data-id="element-36" data-mp="1t4r9bbk3ll2e">$27</span>{" "}
          <span className="text-muted" data-id="element-37" data-mp="1o5y6qe6cneh0">USD por mes · Cancelás cuando querés</span>
        </p>
        <CtaButtons data-id="element-38" data-mp="223w72fnu5adi" />
      </div>
    </section>;
}